import React, { useEffect, useState } from "react";
import { Layout, message, Spin } from "antd";
import { useSetRecoilState, useRecoilValue } from "recoil";
import { tenantsInfo as recoilTenantsInfo } from "../../recoil";
import { envConfig } from "../../envConfig";
import { i18n as i } from "@/i18n";
import { Outlet } from "react-router-dom";
import { getToken, getTenantsInfo } from "../../api";
import "../mainLayout.less";
import {
  getAccessToken,
  setAccessToken,
  setRefreshToken,
  clearToken,
} from "../../utils/sessionToken";
import { getSSOTicket, goLogout, getAppUrl } from "../../utils/sso";
import GlobalHeader from "@/components/GlobalHeader";
import _ from "lodash";
import { convertContext } from "@/gs-utils/core/utils";
import Watermark from "@/components/WaterMark";

const { Content } = Layout;

function MainLayout() {
  const setTenantsInfo = useSetRecoilState(recoilTenantsInfo);
  const tenantsInfo = useRecoilValue(recoilTenantsInfo);
  const [loading, setLoading] = useState(true);

  // ticket交换token
  const runGetTokenAsync = async (ticket: string) => {
    try {
      setLoading(true);
      const { data } = await getToken(ticket);
      if (data) {
        const accessToken = _.get(data, "accessToken", "");
        const refreshToken = _.get(data, "refreshToken", "");
        if (accessToken) {
          setAccessToken(accessToken);
          setRefreshToken(refreshToken);
          window.location.href = getAppUrl();
        } else {
          message.error(i("token获取失败，请重新登录"));
          goLogout();
        }
      }
    } catch (err) {
      console.log(err);
      message.error(i("token获取失败，请重新登录"));
      goLogout();
    } finally {
      setLoading(false);
    }
  };

  // 获取用户信息
  const runGetTenantsInfo = async () => {
    try {
      setLoading(true);
      const resp = await getTenantsInfo();
      const { data } = resp;
      const tenantsInfo = convertContext(data);
      if (tenantsInfo.internalPerson === false) {
        // 清除当前应用token并跳转到服务url
        clearToken();
        window.location.href = envConfig.serviceUrl;
        return;
      }
      setTenantsInfo(tenantsInfo);
    } catch {
      message.error(i("用户信息获取失败，请重新登录"));
      setTimeout(() => {
        goLogout();
      }, 1000);
    } finally {
      setLoading(false);
    }
  };

  // 非乾坤主视图加载逻辑
  useEffect(() => {
    const accessToken = getAccessToken();
    const ticket = getSSOTicket();
    // 优先级1: SSO ticket交换
    if (ticket) {
      runGetTokenAsync(ticket);
      return;
    }

    // 优先级2: 本地缓存的accessToken
    if (accessToken) {
      runGetTenantsInfo();
      return;
    }

    // 兜底: 跳转到登录页面
    window.location.href = `${envConfig.login}?app=${encodeURIComponent(
      getAppUrl()
    )}`;
  }, []);

  const person = tenantsInfo?.person;

  return (
    <Spin spinning={loading} size="large" wrapperClassName="wrapper-spin">
      <Watermark
        watermarkText={person?.username || person?.displayName || person?.email}
      />
      <Layout className="main">
        <GlobalHeader />
        <Layout>
          {/* <SiderMenu /> */}
          <Layout style={{ position: "relative" }}>
            <Content>
              <div
                className="site-layout-background"
                style={{
                  minHeight: 360,
                  overflow: "auto",
                  backgroundColor: "#f0f2f5",
                }}
              >
                <Outlet />
              </div>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </Spin>
  );
}

export default MainLayout;
